exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".module-statistic[data-v-3fee451e]{padding-top:.96rem;background-color:#f6f8fb}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/BookNumberDesc.vue"],"names":[],"mappings":"AACA,mCACE,mBAAqB,AACrB,wBAA0B,CAC3B","file":"BookNumberDesc.vue","sourcesContent":["\n.module-statistic[data-v-3fee451e] {\n  padding-top: 0.96rem;\n  background-color: #f6f8fb;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fee451e","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/BookNumberDesc.vue
// module id = MBS+
// module chunks = 0 2